import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SchoolShell from '../../components/school/SchoolShell';
import { useSchoolAuth } from '../../context/SchoolAuthContext';
import api from '../../utils/api';

const SchoolDashboardPage = () => {
  console.log('SchoolDashboardPage rendered');
  const { school } = useSchoolAuth();
  console.log('school from context:', school);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => { loadStats(); }, []);

  const loadStats = async () => {
    try {
      const res = await api.get('/schools/dashboard');
      setStats(res.data.data);
    } catch {}
    finally { setLoading(false); }
  };

  return (
    <SchoolShell title="Dashboard" subtitle={school ? 'Welcome back, ' + (school.principal_name || school.name) : ''}>
      {loading ? (
        <div style={{ textAlign: 'center', padding: '60px', color: '#64748B' }}>Loading...</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px' }}>
            {[
              { icon: '👨‍🎓', val: stats?.total_students || 0, lbl: 'Total Students', color: '#1A3C6E', bg: '#E8F0FB' },
              { icon: '✅', val: stats?.active_students || 0, lbl: 'Active Students', color: '#1B7F3E', bg: '#E6F4EC' },
              { icon: '⏳', val: stats?.pending_students || 0, lbl: 'Pending Approval', color: '#B45309', bg: '#FEF3C7' },
              { icon: '📊', val: stats?.avg_mastery || 0, lbl: 'Avg Mastery Score', color: '#FF6B00', bg: '#FFF3E0' },
            ].map(s => (
              <div key={s.lbl} style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ width: '42px', height: '42px', borderRadius: '10px', background: s.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 }}>{s.icon}</div>
                <div>
                  <div style={{ fontSize: '22px', fontWeight: 900, color: s.color, lineHeight: 1 }}>{s.val}</div>
                  <div style={{ fontSize: '10px', color: '#64748B', fontWeight: 600, marginTop: '2px' }}>{s.lbl}</div>
                </div>
              </div>
            ))}
          </div>

          <div style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '12px', padding: '20px' }}>
            <div style={{ fontSize: '13px', fontWeight: 800, marginBottom: '14px' }}>Quick Actions</div>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              {[
                { icon: '➕', label: 'Add Student', path: '/school/add-student', color: '#FF6B00' },
                { icon: '📤', label: 'Bulk Upload CSV', path: '/school/bulk-upload', color: '#1A3C6E' },
                { icon: '✅', label: 'Pending Approvals', path: '/school/students', color: '#B45309' },
                { icon: '📈', label: 'View Performance', path: '/school/performance', color: '#1B7F3E' },
                { icon: '📢', label: 'Send Announcement', path: '/school/announcements', color: '#7C3AED' },
              ].map(a => (
                <button key={a.label} onClick={() => navigate(a.path)}
                  style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 16px', borderRadius: '10px', background: '#F7F8FC', border: '1px solid #E2E8F0', fontSize: '12px', fontWeight: 700, color: a.color, cursor: 'pointer' }}>
                  {a.icon} {a.label}
                </button>
              ))}
            </div>
          </div>

          <div style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '12px', padding: '20px' }}>
            <div style={{ fontSize: '13px', fontWeight: 800, marginBottom: '14px' }}>School Information</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              {[
                { lbl: 'School Name', val: school?.name },
                { lbl: 'CBSE Affiliation No.', val: school?.cbse_affiliation_no },
                { lbl: 'Principal', val: school?.principal_name },
                { lbl: 'Email', val: school?.email },
                { lbl: 'Phone', val: school?.phone },
                { lbl: 'City', val: school?.city },
              ].map(f => (
                <div key={f.lbl} style={{ padding: '10px 12px', background: '#F7F8FC', borderRadius: '8px' }}>
                  <div style={{ fontSize: '10px', color: '#64748B', fontWeight: 700, textTransform: 'uppercase', marginBottom: '3px' }}>{f.lbl}</div>
                  <div style={{ fontSize: '13px', fontWeight: 700 }}>{f.val || '—'}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </SchoolShell>
  );
};

export default SchoolDashboardPage;
